<template>
  <div
    class="chartContainer"
    data-automation="stats-chart"
  >
    <canvas ref="chartCanvas" />
  </div>
</template>

<script>

import Chart from 'chart.js'

export default {
  name: 'StatsDailyChart',
  props: {
    dailyData: {
      type: Array,
      required: true,
    },
    cumulativeData: {
      type: Array,
      required: true,
    },
    period: {
      type: Number,
      required: true,
    },
    cumulativeLabel: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      chart: null,
    }
  },
  computed: {
    unit: function () {
      return this.period <= 90 ? 'day' : 'month'
    },
  },
  watch: {
    dailyData: function (value) {
      this.chart.data.datasets[0].data = value
      this.chart.update()
    },
    cumulativeData: function (value) {
      this.chart.data.datasets[1].data = value
      this.chart.update()
    },
    period: function (value) {
      this.chart.options.scales.xAxes[0].time.unit = this.unit
      this.chart.update()
    },
  },
  mounted: function () {
    this.chart = new Chart(this.$refs.chartCanvas, {
      type: 'line',
      data: {
        datasets: [{
          label: 'daily',
          data: this.dailyData,
          borderColor: [
            '#5d4c45',
          ],
          backgroundColor: [
            '#5d4c45',
          ],
          borderWidth: 1,
          fill: false,
          pointRadius: 1,
        },
        {
          label: this.cumulativeLabel,
          data: this.cumulativeData,
          borderColor: [
            '#a3c586',
          ],
          backgroundColor: [
            '#a3c586',
          ],
          borderWidth: 1,
          fill: false,
          pointRadius: 1,
        }],
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
          }],
          xAxes: [{
            id: 'time-axis',
            type: 'time',
            time: {
              unit: this.unit,
            },
          }],
        },
      },
    })
  },
}

</script>
